module.exports = __webpack_public_path__ + "media/customizations/riverlights/back-932b65edf01d9e3e724eff988385e358.jpg";